import { render, staticRenderFns } from "./InstallApp.vue?vue&type=template&id=0b713794&"
import script from "./InstallApp.vue?vue&type=script&lang=js&"
export * from "./InstallApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports